import React from "react";
import Utils from "Utils/utils";
import PreviewEditorTemplate from "Components/common/PreviewEditorTemplate";
import { observer } from "mobx-react";

import { writingAssistantStoreData } from "Stores/WritingAssistantData";

const PreviewSequenceTemplate = observer(props => {
  const {
    contentBody = "",
    attachments = [],
    subject = "",
    currentStage = 1,
    replyAsThread = false,
    hasTitle = false,
    dynamicInboxId = false,
    fromAddress = "",
    autoAppendSignature = true
  } = props || {};

  const previewDom = dynamicInboxId
    ? Utils.getContentWithSignature(
      contentBody,
      dynamicInboxId,
      fromAddress?.email,
      autoAppendSignature
    )
    : Utils.getContentWithSignature(contentBody, [], "", autoAppendSignature);

  return (
    <div className="previewContentWrap">
      <PreviewEditorTemplate
        subject={replyAsThread ? "Re: [Previous email subject line]" : subject}
        contentBody={Utils.contentReadyOnly(previewDom?.outerHTML)}
        attachments={attachments || []}
        currentStage={currentStage}
        inboxIds={dynamicInboxId ? [dynamicInboxId] : []}
        titleText="Preview Sequence"
        hasTitle={hasTitle}
        sampleParsedSpintax={writingAssistantStoreData?.sampleParsedSpintax}
      />
    </div>
  );
});

export default PreviewSequenceTemplate;
export { PreviewSequenceTemplate };
